<template>
    <tr :class="{'text-gray-500': reservation.status !== 'confirmed'}">
        <td class="px-6 py-3" v-if="withDate">
            <span v-show="isSameDay">{{ reservation.from | date }}</span>
            <span v-show="!isSameDay">{{ reservation.from | date }} - {{ reservation.to | date }}</span>
        </td>
        <td class="px-6 py-3">
            <desk-item v-for="desk in desks" :key="desk.id" :item="desk"></desk-item>
        </td>
        <td class="px-6 py-3">
            {{ truncate(reservation.comment) }}
            {{ reservation.user ? reservation.user.name : '' }}
        </td>
        <td class="px-2 py-3 text-right">
            <confirm-dialog @confirmed="remove" @canceled="remove(true)" v-show="reservation.status === 'confirmed'">
                <template v-slot:header>Buchung löschen</template>
                <template v-slot:question>
                    <span>
                      Soll die Buchung von
                      <span class="font-bold">{{ reservation.schedules[0].desk.name }}</span>
                      wirklich gelöscht werden?
                    </span>
                  <span v-show="!isSameDay"> Die ausgewählte Buchung für den <span
                      class="font-bold">{{ reservation.schedules[0].from | date }}</span> ist Teil einer Serienbuchung. Möchten Sie nur die Buchung für den <span
                      class="font-bold">{{ reservation.schedules[0].from | date }}</span> löschen, oder die gesamte Serie ab Heute?</span>
                </template>
                <template v-slot:confirm>Buchung löschen</template>
                <template v-slot:cancel v-show="!isSameDay">
                  Serie löschen
                </template>
                <button-delete><i class="fa fa-trash"></i></button-delete>
            </confirm-dialog>
        </td>
    </tr>
</template>

<script>
import ButtonWhite from "./UI/ButtonWhite";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonDelete from "./UI/ButtonDelete";
import DeskItem from "./DeskItem.vue";

export default {
    name: "Reservation",
    components: {DeskItem, ButtonDelete, ConfirmDialog, ButtonWhite},
    props: {
        reservation: Object,
        withDate: {
            type: Boolean,
            default: false,
        }
    },

    data: () => ({
        loading: false,
    }),

    computed: {
        desks() {
            return this.reservation.schedules.filter(s => s.day === this.reservation.from).map(s => s.desk);
        },
        isSameDay() {
            return this.reservation.from === this.reservation.to;
        }
    },

    methods: {
        remove(deleteSeries = false) {
            this.loading = true;
            this.$http.delete(`/admin/reservations/${this.reservation.id}`,{
              params: {
                deleteSeries: deleteSeries
              }
            }).then(() => {
                    this.loading = false;
                    this.reservation.status = 'released';
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        truncate(val) {
            if (this.withDate) {
                return val;
            }
            if (val.length > 25) {
                return val.substring(0, 22) + ' ...';
            }
            return val;
        }
    }
}
</script>

<style scoped>

</style>
